import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AgreementInteractor } from "../iteractor/agreement.interactor";
import { AgreementRequest, CreateProjectRequest, GetAgreementsRequest } from "./interfaces/agreement.request";
import { AgreementResult, ProjectResult } from './interfaces/agreement.result';
import { IsRequestComplete } from '../../../../../interfaces/isrequest-complete';
import { AgreementModel } from "src/app/models/customers/agreement.model";
import { ProjectModel } from "src/app/models/customers/project.model";



@Injectable({providedIn:'root'})
export class AgreementPresenter implements AgreementRequest, GetAgreementsRequest, CreateProjectRequest,
AgreementResult, ProjectResult, IsRequestComplete {

private result: AgreementResult;
private _resultProject: ProjectResult;
private _isRequestComplete: IsRequestComplete;

constructor(private interactor: AgreementInteractor) {
  interactor.setPresenter(this);
}

setRequestCompleteComponent(isRequestComplete: IsRequestComplete){
  this._isRequestComplete = isRequestComplete;
}

setRequestProjectComponent(result: ProjectResult){
  this._resultProject = result;
}

setComponent(result: AgreementResult){
  this.result = result;
}

isRequestComplete(status: boolean, error?: HttpErrorResponse, data?: object | any[]): void {
 this._isRequestComplete.isRequestComplete(status, error, data);
}

isEditedResponseSuccess(): void {
  this.result.isEditedResponseSuccess();
}

isCreateProjectResponse(response: HttpResponse<any>) {
  this._resultProject.isCreateProjectResponse(response);
}

getResponse(response: HttpResponse<any>): void {
  this.result.getResponse(response);
}

getAgreements(): Promise<AgreementModel[]> {
    return this.interactor.getAgreements();
}

getMasterAgreements(): Promise<AgreementModel[]> {
  return this.interactor.getMasterAgreements();
}

newAgreement(agreement: FormData): void {
  this.interactor.newAgreement(agreement);
}

editAgreement(agreement: AgreementModel): void {
 this.interactor.editAgreement(agreement);
}

getClientInfo(id: string): Promise<any> {
  return this.interactor.getClientInfo(id);
}

newProject(project: ProjectModel): Promise<ProjectModel> {
   return this.interactor.newProject(project);
}

getProject(id: any): Promise<ProjectModel> {
    return this.interactor.getProject(id);
}

}
